import {AiFillGithub} from "react-icons/all";

export default function GithubRepo({repo}) {
    return (
        <div className={"git-repo col-lg-4 col-md-6 col-sm-6 col-xs-12 d-flex align-items-stretch background-transparent"}>
            <div className="card w-100 git-card blur">
                <div className="card-body text-muted">
                    <h5 className="card-title">{repo.name}</h5>
                    <h6 className="card-subtitle mb-2 text-muted">Last updated: {repo.DateStr}</h6>
                    <h6 className="card-subtitle mb-2 text-muted">Technology: {repo.language}</h6>
                    <p className="card-text">{repo.description}</p>
                </div>
                <div className={"card-footer text-right"}>
                    <a href={repo.html_url} className="card-link align-bottom d-inline">GitHub <AiFillGithub size={"2rem"}/></a>

                </div>

            </div>

        </div>
    );
}


